import { Controller } from "@hotwired/stimulus"

// Makes a non-native `role="button"` element (a <div>/<span> standing in for a real button,
// typically because it needs to wrap other interactive content like a link, which a real
// <button> can't contain) keyboard-operable. Native buttons and links fire a click on Enter/Space
// automatically; a div with role="button" does not, so screen-reader and keyboard users can focus
// it (given tabindex="0") but never activate it without this.
//
// Usage: add `data-controller="clickable-div"
//         data-action="keydown.enter->clickable-div#activate keydown.space->clickable-div#activate"`
// alongside `role="button" tabindex="0"` on the element.
export default class extends Controller {
  activate(event) {
    event.preventDefault()
    this.element.click()
  }
}
